import { ISearchParams } from "@/repositories/search.repository"

export const SearchService = {
  Get: (params: ISearchParams) => SearchRepository.Get(params),
}
